import styled from "styled-components";

const SalePointsPartnerPanelStyled = styled.div`

`;

export default SalePointsPartnerPanelStyled;